import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

import { FileIcon, Download } from '../../../icons';

interface UnsupportedRendererProps {
  fileName: string;
  mimeType?: string;
  fileSizeBytes?: number;
  /**
   * Save the file. Absent, no Download button is rendered (GitLab #1539): the
   * source decides whether a save is possible, e.g. not while offline. Until
   * #1539 this went straight to `attachmentService.downloadAttachment`.
   */
  onDownload?: () => void | Promise<void>;
}

export const UnsupportedRenderer: React.FC<UnsupportedRendererProps> = ({
  fileName,
  mimeType,
  fileSizeBytes,
  onDownload,
}) => {
  const formatSize = (bytes?: number) => {
    if (!bytes) return '';
    const kb = bytes / 1024;
    if (kb < 1024) return `${kb.toFixed(0)} KB`;
    return `${(kb / 1024).toFixed(1)} MB`;
  };

  return (
    <View style={styles.container}>
      <FileIcon size={64} color="rgba(255,255,255,0.5)" />
      <Text style={styles.name} numberOfLines={3}>
        {fileName}
      </Text>
      {mimeType ? <Text style={styles.meta}>{mimeType}</Text> : null}
      {fileSizeBytes ? (
        <Text style={styles.meta}>{formatSize(fileSizeBytes)}</Text>
      ) : null}
      <Text style={styles.message}>Preview not available</Text>
      {onDownload ? (
        <TouchableOpacity
          style={styles.downloadButton}
          onPress={() => {
            void onDownload();
          }}
          accessibilityRole="button"
          accessibilityLabel={`Download ${fileName}`}
          testID="carousel-unsupported-download"
        >
          <Download size={18} color="#fff" />
          <Text style={styles.downloadText}>Download to view</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#000',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 32,
    gap: 12,
  },
  name: {
    color: '#fff',
    fontSize: 16,
    fontWeight: '600',
    textAlign: 'center',
    marginTop: 8,
  },
  meta: {
    color: 'rgba(255,255,255,0.5)',
    fontSize: 12,
    textAlign: 'center',
  },
  message: {
    color: 'rgba(255,255,255,0.6)',
    fontSize: 14,
    marginTop: 8,
  },
  downloadButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    backgroundColor: '#1a73e8',
    paddingHorizontal: 24,
    paddingVertical: 12,
    borderRadius: 8,
    marginTop: 8,
  },
  downloadText: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '600',
  },
});
